import { type Template } from 'server/ai/consts'

export const TEMPLATE_SIX_SUFFIX = '_six' // The suffix for the six-tile templates

/**
 * Returns the base/canonical slug for a template.
 * Used for preview images, analytics grouping, and display purposes.
 * - Variants return their parent's slug (variant_of_slug)
 * - WALL_SQUARE_SIX templates return slug without _six suffix
 * - Regular templates return their slug as-is
 */
export function getBaseSlug(template: Template): string {
  if (template.variant_of_slug) {
    return template.variant_of_slug
  }
  if (template.slug.endsWith(TEMPLATE_SIX_SUFFIX)) {
    return template.slug.replace(TEMPLATE_SIX_SUFFIX, '')
  }
  return template.slug
}

// Override priority: regular (1) < six-tile (2) < variant (3)
function getTemplatePriority(template: Template): number {
  if (template.variant_of_slug) return 3
  if (template.template_type === 'WALL_SQUARE_SIX') return 2
  return 1
}

export function filterTemplates(
  templates: Template[],
  firstTemplate: string | null,
  templateSlugsWhitelist?: string[]
) {
  let filtered = templates

  if (templateSlugsWhitelist && templateSlugsWhitelist.length > 0) {
    filtered = filtered.filter(
      (template) =>
        templateSlugsWhitelist.includes(template.slug) ||
        template.slug === firstTemplate
    )
  }

  // Sort by priority: regular < six-tile < variant (the higher priority appears later in the array)
  const sorted = [...filtered].sort(
    (a, b) => getTemplatePriority(a) - getTemplatePriority(b)
  )

  // Assign each template to its baseSlug (so experiment slugs override the original ones)
  const templatesBySlug = new Map<string, Template>()
  for (const template of sorted) {
    templatesBySlug.set(getBaseSlug(template), template)
  }

  return Array.from(templatesBySlug.values()).sort((a, b) => a.order - b.order)
}
